import ViewAdvertisement from "./ViewAdvertisement";
import { VIEW_STORE_ROUTE, STORES_ROUTE } from "../Stores/routes";

export { VIEW_STORE_ROUTE, STORES_ROUTE};

export const ADD_ADS_ROUTES = VIEW_STORE_ROUTE + "/:id/ads";
export const routes = [
    {
        path: "/stores/view/:id/ads",
        component: ViewAdvertisement,
        exact: true
    },
    {
        path: "/stores/view/:id/ads/:adsId",
        component: ViewAdvertisement,
        exact: true
    }
];